import fileDownload from 'js-file-download';
import Axios from 'axios';
import { toast } from 'react-toastify';
import getJobAttachment from './getJobAttachment';

const downloadAttachment = async (
  id,
  attachmentId,
  attachmentName,
  setDownloadInProcess
) => {
  try {
    const jobAttachmentUrl = await getJobAttachment(
      id,
      attachmentId,
      attachmentName
    );

    if (jobAttachmentUrl) {
      const jobAttachment = await Axios.get(jobAttachmentUrl.url, {
        responseType: 'blob',
      });
      if (jobAttachment) {
        fileDownload(jobAttachment.data, attachmentName);
      }
    }
  } catch (error) {
    toast.error('Error while downloading file');
  } finally {
    setDownloadInProcess(false);
  }
};

export default downloadAttachment;
